"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propsMain = _interopRequireDefault(require("./props-main"));
// import eventTable from './event-table'
// import eventPagination from './event-pagination'
var _default = exports.default = [_propsMain.default /* , eventTable, eventPagination */];